const hexToRgb = (hex) => {
  const n = parseInt(hex.replace("#", ""), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

// Line pixels from the original art act as walls so dark fills can still be re-coloured.
export function buildLineMask(imageData) {
  const d = imageData.data;
  const mask = new Uint8Array(imageData.width * imageData.height);
  for (let p = 0, i = 0; p < mask.length; p++, i += 4) {
    if (d[i] < 110 && d[i + 1] < 110 && d[i + 2] < 110) mask[p] = 1;
  }
  return mask;
}

export function floodFill(ctx, mask, x, y, hex, tolerance = 60) {
  const { width: w, height: h } = ctx.canvas;
  const start = y * w + x;
  if (x < 0 || y < 0 || x >= w || y >= h || mask[start]) return false;
  const img = ctx.getImageData(0, 0, w, h);
  const d = img.data;
  const [fr, fg, fb] = hexToRgb(hex);
  const si = start * 4;
  const sr = d[si], sg = d[si + 1], sb = d[si + 2];
  if (Math.abs(sr - fr) + Math.abs(sg - fg) + Math.abs(sb - fb) < 6) return false;
  const seen = new Uint8Array(w * h);
  const match = (p) => {
    if (mask[p] || seen[p]) return false;
    const i = p * 4;
    return Math.abs(d[i] - sr) + Math.abs(d[i + 1] - sg) + Math.abs(d[i + 2] - sb) <= tolerance;
  };
  const stack = [[x, y]];
  while (stack.length) {
    let [cx, cy] = stack.pop();
    let p = cy * w + cx;
    while (cx >= 0 && match(p)) { cx--; p--; }
    cx++; p++;
    let up = false, down = false;
    while (cx < w && match(p)) {
      const i = p * 4;
      d[i] = fr; d[i + 1] = fg; d[i + 2] = fb; d[i + 3] = 255;
      seen[p] = 1;
      if (cy > 0) {
        if (match(p - w)) { if (!up) { stack.push([cx, cy - 1]); up = true; } } else up = false;
      }
      if (cy < h - 1) {
        if (match(p + w)) { if (!down) { stack.push([cx, cy + 1]); down = true; } } else down = false;
      }
      cx++; p++;
    }
  }
  ctx.putImageData(img, 0, 0);
  return true;
}
